export default "__VITE_ASSET__A0AmjJLx__"